module.exports = __webpack_public_path__ + "media/demo3-kr.7ba097f8.mp4";